// axios配置文件
import axios from 'axios';
import { Messages as Message } from "../UI";
import { addParams } from "./commonParams";
import { getCookieVal } from "@/tool/index";
import { refreshLoginInfo } from "./updateToken";


const service = axios.create({
  baseURL: process.env.VUE_APP_API, // API的base_url
  timeout: 300000 // 请求超时时间
});
let flag = false
// 请求拦截器
service.interceptors.request.use(
  config => {
    if (config.sign) addParams(config);
    refreshLoginInfo();
    config.headers.token = getCookieVal("iyuanwu_token")
    return config;
  },


  error => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做处理，例如只返回data部分

    const data = response.data;
    if (data.code == 2) {
      Message({
        type: "error",
        message: data.message,
      })
    }
    if(data.code==403||(data&&data.code==404&&!flag)){

      Message({
        type: "error",
        message: "抱歉，您的登录状态已失效，请重新登录！",
      })
      flag=true
      setTimeout(()=>{
        flag=false
        window.location.replace(process.env.VUE_APP_LOGIN,'_self')
      },2000)

    }

    return data;
  },
  error => {
    // 响应错误处理

    if (error.code == 'ECONNABORTED') {
      Message({
        type: "error",
        message: '请求超时，请重新尝试',
        customClass: "global-messageZindex", // message 类名
      });
    }
    else {
      Message({
        type: "error",
        message: error,
        customClass: "global-messageZindex", // message 类名
      });
    }
    return Promise.reject(error);
  }
);

export default service;